import { render, staticRenderFns } from "./subjectForm.vue?vue&type=template&id=33594ff7&"
import script from "./subjectForm.vue?vue&type=script&lang=js&"
export * from "./subjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports